<ng-container *ngIf="numberAsdms; else zeroAsdms">
  <asax-result-table-search-table-cell-popover [text]="numberAsdms">
    <title *ngTemplateOutlet="asdmsTitle"></title>
    <content *ngTemplateOutlet="asdmsContent"></content>
  </asax-result-table-search-table-cell-popover>
</ng-container>

<ng-template #asdmsTitle>
  Asdm
</ng-template>

<ng-template #asdmsContent>
  <ng-container *ngIf="!isLoading; else loading">
    <ngx-datatable class="result-table-popover material striped m-1"
                   [style.width.px]="250"
                   [style.height.px]="numberAsdms > 6 ? (6 * rowHeight) + headerHeight : (numberAsdms * rowHeight) + headerHeight"
                   [columnMode]="ColumnMode.force"
                   [messages]="{emptyMessage: '', totalMessage: 'total'}"
                   [headerHeight]="headerHeight"
                   [rowHeight]="rowHeight"
                   [rows]="rows"
                   [sortType]="SortType.single"
                   [scrollbarH]="true"
                   [scrollbarV]="true">
      <ngx-datatable-column name="Asdm" prop="asdm"></ngx-datatable-column>
    </ngx-datatable>
  </ng-container>
</ng-template>

<ng-template #loading>
  <div class="d-flex justify-content-center">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>

<ng-template #zeroAsdms>
  <span class="badge bg-light text-dark border border-dark w-100 fw-light"
        style="font-size: 11px">
   0
  </span>
</ng-template>
